module.exports = __webpack_public_path__ + "ath_game_web/img/9.1.8d994e61.png";